module.exports = __webpack_public_path__ + "img/vote.296f9d07.png";